import {useState} from 'react';
import type {RouteComponentProps} from 'react-router-dom';

import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DiscardForm as DiscardFormMutation,
    DiscardFormVariables as DiscardFormMutationVariables,
    MultiPageFormFragment,
    FormPublishInput,
    FormUpdateInput,
} from 'nutshell-graphql-types';

import FORM_DISCARD from '../../graphql/mutations/discard-form.graphql';

import {FullPageFormEditorContent} from './full-page-form-editor-content';
import {convertGraphQLResponseToMultiPageForm} from './helpers';

interface Props extends RouteComponentProps {
    onPublishForm: (input: FormPublishInput) => Promise<any>;
    onClose: () => void;
    form: MultiPageFormFragment;
    updateMultiPageForm: (input: FormUpdateInput) => Promise<any>;
    formHeader?: React.ReactNode;
    refetchForm: () => Promise<any>;
    minimumOneEmailField?: boolean;
    isMeetingForm?: boolean;
}

export function FullPageFormEditor(props: Props) {
    const [saveFailedErrorMessage, setSaveFailedErrorMessage] = useState<string | null | undefined>(
        null
    );
    const [discardForm] = useMutation<DiscardFormMutation, DiscardFormMutationVariables>(
        FORM_DISCARD
    );

    return (
        <FullPageFormEditorContent
            {...props}
            formDefaultValues={convertGraphQLResponseToMultiPageForm(props.form)}
            onUpdateForm={(input: FormUpdateInput) => {
                return props.updateMultiPageForm(input).catch((error: Error) => {
                    // @ts-expect-error
                    const errorMessage = safelyGetGraphQLErrorMessage(error);
                    setSaveFailedErrorMessage(errorMessage);
                });
            }}
            onDiscardForm={(formId: string) => {
                return discardForm({variables: {input: {formId}}});
            }}
            saveFailedErrorMessage={saveFailedErrorMessage}
            onClearError={() => setSaveFailedErrorMessage(null)}
            onFieldCreateFailed={setSaveFailedErrorMessage}
        />
    );
}
